export default __webpack_public_path__ + "static/media/segre01min.d87211e5.jpg";